import * as React from "react";
import "./button-view-cart.less";
import { ModalComponent } from "shared/components/modal/modal";
import { useAppDispatch, useAppSelector } from "app.hook";
import { shallowEqual } from "react-redux";
import {
  hideViewCartModal,
  selectShoppingCart,
  selectViewCartModal,
} from "states/shopping-cart/shopping-cart.slice";
import { ItemModalViewMobileCart } from "./components/item-view-cart-mobile";
import { nanoid } from "@reduxjs/toolkit";

export function DisplayFooterViewCart() {
  const currentShoppingCart = useAppSelector(selectShoppingCart, shallowEqual);
  const currentViewCartModal = useAppSelector(
    selectViewCartModal,
    shallowEqual
  );
  const dispatch = useAppDispatch();
  return (
    <>
      {currentShoppingCart?.items?.length > 0 && (
        <ModalComponent
          isCustomizeFooter={true}
          height={`100%`}
          isModal={true}
          className="bottom-20"
          title={"View Cart"}
          isOpenModal={currentViewCartModal}
          onCloseModal={() => {
            dispatch(hideViewCartModal());
          }}
        >
          {currentShoppingCart?.items?.map((m, index) => (
            <ItemModalViewMobileCart key={nanoid()} index={index} item={m} />
          ))}
        </ModalComponent>
      )}
    </>
  );
}
